import React from 'react';
import LeadGenForm from '../Modals/LeadGenForm';

export const getCustomComponentOnCTAClick = ({component, data, handlePopupState, CrossCloseCTACompPopup, changeChatbotData}) => {
    const getComponent = {
        register: {renderComponent: LeadGenForm}
    }
    const CompToRender = getComponent[component].renderComponent
    return <CompToRender data={data} handlePopupState={handlePopupState} CrossCloseCTACompPopup={CrossCloseCTACompPopup} changeChatbotData={changeChatbotData}/>
  }